// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const FileIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M19.71 6.29l-1-1-2-2-1-1A1 1 0 0015 2H5a1 1 0 00-1 1v18a1 1 0 001 1h14a1 1 0 001-1V7a1 1 0 00-.29-.71zM18 20H6V4h8v3a1 1 0 001 1h3z"/></svg>'} />;

FileIcon.displayName = 'FileIcon';

export default FileIcon;
